// Utility functions for bandwidth formatting

/**
 * Format bandwidth value from Mbps to appropriate display format
 * @param {number} bandwidthMbps - Bandwidth in Mbps
 * @returns {string} Formatted bandwidth string
 */
export const formatBandwidth = (bandwidthMbps) => {
  if (!bandwidthMbps || bandwidthMbps === 0) {
    return 'N/A';
  }
  
  const bandwidth = parseInt(bandwidthMbps);
  
  if (bandwidth >= 1000) {
    const gbps = bandwidth / 1000;
    return `${gbps} Gbps`;
  } else {
    return `${bandwidth} Mbps`;
  }
};

/**
 * Convert bandwidth string back to Mbps value
 * @param {string} bandwidthString - Formatted bandwidth string (e.g., "1 Gbps", "500 Mbps")
 * @returns {number} Bandwidth in Mbps
 */
export const parseBandwidth = (bandwidthString) => {
  if (!bandwidthString || bandwidthString === 'N/A') {
    return 0;
  }
  
  if (bandwidthString.includes('Gbps')) {
    const value = parseFloat(bandwidthString.replace(' Gbps', ''));
    return value * 1000;
  } else if (bandwidthString.includes('Mbps')) {
    return parseInt(bandwidthString.replace(' Mbps', ''));
  }
  return 0;
};